if (!customElements.get('aryveda-side-nav')) {
  class ArvyedaSideNav extends HTMLElement {
    constructor() {
      super();

      this.links = Array.from(this.querySelectorAll('.ald-sidenav__link'));
      this.entries = this.links
        .map((link) => {
          const target = document.getElementById(link.dataset.target);
          return target ? { link, target } : null;
        })
        .filter(Boolean);

      this.links.forEach((link) => {
        link.addEventListener('click', this.onLinkClick.bind(this));
      });

      if (this.entries.length === 0) return;

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
        rootMargin: '-40% 0px -40% 0px',
        threshold: 0,
      });

      this.entries.forEach(({ target }) => this.observer.observe(target));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onIntersection(observedEntries) {
      observedEntries.forEach((observedEntry) => {
        const match = this.entries.find(({ target }) => target === observedEntry.target);
        if (!match) return;
        match.link.classList.toggle('is-active', observedEntry.isIntersecting);
      });
    }

    onLinkClick(event) {
      const link = event.currentTarget;
      const target = document.getElementById(link.dataset.target);
      if (!target) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  }

  customElements.define('aryveda-side-nav', ArvyedaSideNav);
}
